export const contactsData = {
    email: 'vedpratap.rajpoot@gmail.com',
    phone: '+917489463485',
    address: 'Whitefield, Banglore, India - 560066',

    sheetAPI: ''
}